angular.module("vgresiduos").controller("createVehiclePopupCtrl", [
	"$scope",
	"$rootScope",
	"dialogService",
	"supplierCode",
	function ($scope, $rootScope, dialogService, supplierCode) {
		"use strict";

		$scope.labels = $rootScope.labels;
		$scope.supplierCode = supplierCode;
		$scope.queries = [{ label: "popupForm", value: true }];

		$scope.$on(Vgr.constants.evtIframeOnSuccessCreateVehicle, function (event, data) {
			dialogService.confirm(data);
		});

		$scope.$on(Vgr.constants.evtIframeOnCancelCreateVehicle, function (event, data) {
			dialogService.hide($scope.dialog);
		});
	}
]);
